import React from "react";
import BondGeneralInformationBase from "../../shared/components/BondGeneralInformationBase";
import { GENERAL_INFORMATION_CONFIG } from "../../shared/generalInformationConfig";
import { BOND_STEP_GLOBAL_DATA_ERRORS } from "../../shared/bondWizardStepPropTypes";

const GeneralInformation = (props) => (
  <BondGeneralInformationBase
    cfg={GENERAL_INFORMATION_CONFIG.trustee.creation}
    {...props}
  />
);

GeneralInformation.propTypes = BOND_STEP_GLOBAL_DATA_ERRORS;

export default GeneralInformation;
